// extracted by css-extract-rspack-plugin
export default {"TriggerContainer":"gpQzb","TriggerContainerIcon":"vyPtZ","TextSchema":"oKqFr","BackButtonLabel":"CIye_"};